module.exports = __webpack_public_path__ + "static/media/solidity-intermediate.bead071a.png";